'use client';

import { c as _c } from "react/compiler-runtime";
import type { Data } from '@repo/strapi-types';
import { useTranslations } from 'next-intl';
import AppLink from '@/components/elementary/AppLink';
import { ArrowRight } from '@/components/icons/ArrowRight';
import { BasicImage } from '@/components/page-builder/components/BasicImage';
import Heading from '@/components/typography/Heading';
import { Paragraph } from '@/components/typography/Paragraph';
import { CASE_STUDIES_FILTERS_TEST_IDS } from '@/lib/test-ids';
import { getCaseStudyLink } from '@/utils/links';
export function CaseStudyCard(props) {
  const $ = _c(23);
  const {
    slug,
    title,
    primaryImage,
    previewImage,
    brandTitle
  } = props;
  const t = useTranslations("CaseStudyCard");
  let t0;
  if ($[0] !== previewImage || $[1] !== primaryImage) {
    t0 = primaryImage || previewImage ? <div className="relative h-67.25 w-full rounded-xl border border-brand-black overflow-hidden"><BasicImage component={previewImage ?? primaryImage} fill={true} className="object-cover" /></div> : null;
    $[0] = previewImage;
    $[1] = primaryImage;
    $[2] = t0;
  } else {
    t0 = $[2];
  }
  let t1;
  if ($[3] !== brandTitle) {
    t1 = <Paragraph fontSize="bodyRegularLarge" textColor="black">{brandTitle}</Paragraph>;
    $[3] = brandTitle;
    $[4] = t1;
  } else {
    t1 = $[4];
  }
  let t2;
  if ($[5] !== title) {
    t2 = <Heading tag="h3" fontSize="headingMedium">{title}</Heading>;
    $[5] = title;
    $[6] = t2;
  } else {
    t2 = $[6];
  }
  let t3;
  if ($[7] !== slug) {
    t3 = getCaseStudyLink(slug);
    $[7] = slug;
    $[8] = t3;
  } else {
    t3 = $[8];
  }
  let t4;
  if ($[9] === Symbol.for("react.memo_cache_sentinel")) {
    t4 = <ArrowRight className="size-5" />;
    $[9] = t4;
  } else {
    t4 = $[9];
  }
  let t5;
  if ($[10] !== t) {
    t5 = t("readStory");
    $[10] = t;
    $[11] = t5;
  } else {
    t5 = $[11];
  }
  let t6;
  if ($[12] !== title) {
    t6 = <span className="sr-only">{title}</span>;
    $[12] = title;
    $[13] = t6;
  } else {
    t6 = $[13];
  }
  let t7;
  if ($[14] !== t3 || $[15] !== t5 || $[16] !== t6) {
    t7 = <AppLink href={t3} variant="tertiaryLink" className="no-underline font-semibold w-fit" data-test-id={CASE_STUDIES_FILTERS_TEST_IDS.CASE_STUDY_LINK} iconEnd={t4}>{t5} {t6}</AppLink>;
    $[14] = t3;
    $[15] = t5;
    $[16] = t6;
    $[17] = t7;
  } else {
    t7 = $[17];
  }
  let t8;
  if ($[18] !== t0 || $[19] !== t1 || $[20] !== t2 || $[21] !== t7) {
    t8 = <div className="flex flex-col gap-4 flex-1">{t0}{t1}{t2}{t7}</div>;
    $[18] = t0;
    $[19] = t1;
    $[20] = t2;
    $[21] = t7;
    $[22] = t8;
  } else {
    t8 = $[22];
  }
  return t8;
}